@let roleView = $resource();
<unity-page-container
  [contentHeader]="$contentHeader()"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [isLoading]="$resourceLoading()">
  <ng-container notifications />

  <ng-container actions>
    <unity-action-delete-shared
      *unityAuthorize="deleteEntitlement"
      [disabled]="$workflowActionsDisabled()"
      [buttonText]="`Delete ${resourceName}`"
      [confirmationTitle]="`Confirm Delete ${resourceName}?`"
      [confirmationMessage]="
        `Are you sure you want to delete this ${resourceName}? Any users that currently have this Role will be reassigned to the default (Navigator) Role.`
      "
      (deleteEvent)="onDelete()" />
  </ng-container>

  @let formGroup = $formGroup();

  <unity-panel-manage-shared
    [feature]="ROLE_MANAGEMENT_FEATURE_TYPE"
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    [workflowCanChange]="false"
    (saveEvent)="onSave()"
    (detailEditEvent)="onEditChange($event)">
    <kendo-gridlayout [gap]="detailCardGridLayoutGap" [cols]="$cols()" [rows]="$rows()">
      <kendo-gridlayout-item>
        <unity-textbox-control displayName="Name" description="Provide a name." [control]="formGroup.controls.name" />
        <unity-textarea-control displayName="Description" description="Provide a description." [control]="formGroup.controls.description" />
        @let parentRole = roleView?.parent_role;
        @let agency = roleView?.agency;
        @if (agency && parentRole) {
          <unity-gridcell-clickable-shared
            labelText="Parent Role"
            [link]="['/business-partner', agency.id, 'role', parentRole.id]"
            [displayText]="roleView?.parent_role?.name" />
        }
        @let childRolesView = childRoles$ | async | sort;
        @if (childRolesView && childRolesView.length > 0) {
          <kendo-label text="Child Roles">
            @for (childRole of childRolesView; track childRole) {
              <unity-gridcell-clickable-shared
                [link]="['/business-partner', childRole.agency.id, 'role', childRole.id]"
                [displayText]="childDisplayName(childRole)" />
            }
          </kendo-label>
        }
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        @if (roleView) {
          <unity-dashboard-permissions-shared #dashboardPermissions [roleId]="roleView.id" (touchEvent)="onPermissionTouched()" />
        }
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </unity-panel-manage-shared>
  @if (roleView) {
    <unity-grid-user-shared *unityAuthorize="'User:View'" gridTitle="Assigned Users" [roleId]="roleView.id" />
  }
</unity-page-container>
